import type { InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

type Props = InputHTMLAttributes<HTMLInputElement> & {
	label?: string;
	error?: string;
};

export function TextInput({ label, error, className, id, ...props }: Props) {
	const inputId = id ?? props.name;
	return (
		<label className="flex flex-col gap-1.5 text-sm">
			{label ? (
				<span className="text-[13px] font-medium text-fg">{label}</span>
			) : null}
			<input
				id={inputId}
				className={cn(
					"h-9 rounded-[var(--radius-control)] bg-surface px-3 text-sm text-fg",
					"ring-1 ring-[var(--ring-hairline)] outline-none",
					"placeholder:text-fg-muted max-sm:text-base",
					"focus:ring-2 focus:ring-teal-500",
					error && "ring-2 ring-rose-500",
					className,
				)}
				{...props}
			/>
			{error ? <span className="text-xs text-rose-600 dark:text-rose-400">{error}</span> : null}
		</label>
	);
}
